import { create } from 'zustand';
import type { Coordinates, HydroAnalysisResult } from '../types';
import { analyzePoint } from '../services/api';

interface HydroState {
  selectedPoint: Coordinates | null;
  analysisResult: HydroAnalysisResult | null;
  isLoading: boolean;
  error: string | null;
  mapStyle: 'streets' | 'satellite' | 'terrain';

  setSelectedPoint: (point: Coordinates | null) => void;
  runAnalysis: (point: Coordinates) => Promise<void>;
  clearAnalysis: () => void;
  setMapStyle: (style: 'streets' | 'satellite' | 'terrain') => void;
}

export const useHydroStore = create<HydroState>((set, get) => ({
  selectedPoint: null,
  analysisResult: null,
  isLoading: false,
  error: null,
  mapStyle: 'streets',

  setSelectedPoint: (point) => {
    set({ selectedPoint: point, error: null });
    if (point) {
      get().runAnalysis(point);
    }
  },

  runAnalysis: async (point) => {
    set({ isLoading: true, error: null });
    try {
      const result = await analyzePoint(point);
      set({ analysisResult: result, isLoading: false });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Analysis failed';
      set({ error: message, isLoading: false });
    }
  },

  clearAnalysis: () => {
    set({
      selectedPoint: null,
      analysisResult: null,
      error: null,
    });
  },

  setMapStyle: (style) => {
    set({ mapStyle: style });
  },
}));
